import React, { useState } from 'react';
import { IconDesktop, IconUserCheck, IconHourglassHalf, IconBookOpenReader, IconFileCircleQuestion, IconFileLines, IconFilePen,
    IconFileSignature, IconFileWaveform, IconFlagCheckered, IconListCheck, IconMagnifyingGlass, IconMoneyCheckDollar, 
    IconScaleBalanced, IconUsersGear  } from "../../svg";
import './timeline.css';

const ICON_MAP = {
    "book-open-reader": IconBookOpenReader,
    "file-circle-question": IconFileCircleQuestion,
    "file-lines": IconFileLines,
    "file-pen": IconFilePen,
    "file-signature": IconFileSignature,
    "file-waveform": IconFileWaveform,
    "flag-checkered": IconFlagCheckered,
    "hourglass-half": IconHourglassHalf,
    "list-check": IconListCheck,
    "magnifying-glass": IconMagnifyingGlass,
    "money-check-dollar": IconMoneyCheckDollar,
    "scale-balanced": IconScaleBalanced,
    "user-check": IconUserCheck,
    "users-gear": IconUsersGear,
};

const COR_SINALIZADORES = {
    0: "",
    1: "#10B981",
    2: "#f7cc4d",
    3: "#f16262",
    4: "#aa0505",
    5: "#dbdbdb",
    6: "#a0a0a0",
};

const CSS_DOT_CONTAINER = {
    0: "",
    1: "no-prazo",
    2: "em-alerta",
    3: "no-limite",
    4: "expirado",
    5: "dispensar",
    6: "nao-iniciado",
};

const IconRenderer = React.memo(({ iconName, color }) => {
  const SelectedIcon = ICON_MAP[iconName];
  if (!SelectedIcon) {
      return <IconDesktop color="#ccc" />
  }
  return <SelectedIcon color={COR_SINALIZADORES[color]} />;
});

export const TimelineVisibilidade = ({ statuses = [], stepAtual = 1 }) => {
  
  // O currentStep define o progresso linear e qual bolinha está em destaque
  const [currentStep, setCurrentStep] = useState(stepAtual); // Definindo o estado inicial do seu exemplo
  
  const totalSteps = statuses.length;

  return (
    <div className="timeline-wrapper">
      {/* O container agora não precisa mais das linhas de track/progress */}
      <div className="timeline-container">

        {statuses.map((item, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentStep;
          const statusClass = CSS_DOT_CONTAINER[item.configuracoes.idTipoSinalizacaoTimeline] || '';

          // LÓGICA DO CONECTOR: A linha à direita de uma bolinha fica ativa se
          // o passo seguinte já foi alcançado ou superado pelo currentStep.
          const isConnectorActive = stepNumber < currentStep;

          // Defina a cor do ícone baseado no status ou se é passado/futuro
          const iconColor = isActive || stepNumber < currentStep ? "#0d6efd" : "#a0a0a0";

          return (
            <div key={item.id || index} className="timeline-step">
              {/* Criamos um wrapper que vai ser flex-direction: column */}
              <div className="timeline-content-wrapper">
                {/* 1. O Ícone fica em cima */}
                <div className="timeline-icon mb-1 has-tooltip" title={""} data-tooltip={item.legendaMacroEtapa + " - " + item.configuracoes.legenda}>
                  {/* Assumindo que você tem o IconRenderer disponível aqui */}
                    {/* Se item.icon for o nome da string "IconDesktop" */}
                  <IconRenderer iconName={item.icon} color={item.configuracoes.idTipoSinalizacaoTimeline} />
                </div>

                {/* 2. A Bolinha fica embaixo */}
                {/* O container da bolinha aplica as classes de cor e de estado ativo */}
                <div className={`timeline-dot-container has-tooltip ${statusClass} ${item.configuracoes.destaque ? 'active' : ''}`} data-tooltip={item.legendaMacroEtapa + " - " + item.configuracoes.legenda}>
                  <div className="timeline-dot"></div>
                </div>
              </div>

              {/* Renderiza o conector para todos, menos para o último passo */}
              {stepNumber < totalSteps && (
                <div className={`timeline-connector ${isConnectorActive ? 'active' : ''}`}></div>
              )}
            </div>
          );
        })}
      </div>

      {/* Os controles continuam funcionando para mudar o passo ATIVO e a linha de progresso */}
      {/* <div className="timeline-controls">
        <button 
            onClick={() => setCurrentStep(prev => Math.max(1, prev - 1))} 
            disabled={currentStep === 1}
        >
          Anterior
        </button>
        <button 
            onClick={() => setCurrentStep(prev => Math.min(totalSteps, prev + 1))} 
            disabled={currentStep === totalSteps}
        >
          Próximo
        </button>
      </div> */}
    </div>
  );
};